import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import EvaluationQuestions from './EvaluationQuestions';
import EvaluationQuestionsGraded from './EvaluationQuestionsGraded';

import '../../admin.scss';

const EvaluationQuestionsParent = (props) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('formal');

  return (
    <div className="no-color">
      <div className="tabs-ctr tabs-ctr--style2 tabs-ctr--ucase-tabs">
        <button
          className={`tab ${activeTab === 'formal' ? 'active' : ''}`}
          onClick={() => setActiveTab('formal')}
        >
          {t('outcomes.formal')}
        </button>
        <button
          className={`tab ${activeTab === 'graded' ? 'active' : ''}`}
          onClick={() => setActiveTab('graded')}
        >
          {t('outcomes.graded')}
        </button>
      </div>

      {/* Both tabs stay mounted so switching FORMAL/GRADED doesn't reset the
          selected outcome and question list — only visibility toggles. */}
      <div className={activeTab === 'formal' ? '' : 'd-none'}>
        <EvaluationQuestions {...props} />
      </div>
      <div className={activeTab === 'graded' ? '' : 'd-none'}>
        <EvaluationQuestionsGraded {...props} />
      </div>
    </div>
  );
};

export default EvaluationQuestionsParent;
